import useSSRFlags from "./useSSRFlags"

const useIsMobileApp = () => {
  const { isAndroid, isIos } = useSSRFlags()

  return isAndroid || isIos
}

export default useIsMobileApp
